import script from "./Glossary.vue?vue&type=script&setup=true&lang=js"
export * from "./Glossary.vue?vue&type=script&setup=true&lang=js"

import "./Glossary.vue?vue&type=style&index=0&id=9e09111a&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e09111a"]])

export default __exports__